import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-rectangle',
  templateUrl: './button-rectangle.component.html',
  styleUrls: ['./button-rectangle.component.scss']
})
export class ButtonRectangleComponent implements OnInit {

  @Input() item: any = [];

  constructor() {
    // 
  }

  ngOnInit(): void {
    // 
  }

}
